
import React from 'react';

import LoadingOverlay from '../LoadingOverlay/index.jsx';


/**
 * A higher-order component used to wrap components.
 *
 * Will apply a loading overlay to the component until the passed promises have
 * resolved.
 */
export default function(Component, promise, propName) {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        loading: true,
        response: undefined
      };

      this.fetchComplete = this.fetchComplete.bind(this);
      this.onError = this.onError.bind(this);
    }

    fetchComplete(response) {
      if (response) {
        this.setState({
          loading: false,
          response: response
        });
      }
    }

    onError(error) {
      console.error(error);
      this.setState({ loading: false, error: error.message });
    }

    componentDidMount() {
      promise.then(this.fetchComplete).catch(this.onError);
    }

    render() {
      var wrappedProps = Object.assign({}, this.props);

      if (this.state.response) {
        wrappedProps[propName] = this.state.response;
      }

      return (
        <LoadingOverlay disabled={! this.state.loading}>
          <Component {...wrappedProps} />
        </LoadingOverlay>
      );
    }
  };
};

